import $ from 'jquery'

class Mhandle {
  open=false;
  container;
  titleContainer;
  contentContainer;
  constructor(container, titleContainer, contentContainer) {
    this.container=container;
    this.titleContainer=titleContainer;
    this.contentContainer=contentContainer;

    this.attachEventListeners();
  };
  attachEventListeners() {
    this.titleContainer.on("click", ()=>{
      console.log("click");
      this.toggleContent();
    });
  };
  toggleContent() {
    this.open=!this.open;
    if (this.open) {
      this.titleContainer.addClass("open");
      this.contentContainer.slideDown(300);
    } else {
      this.titleContainer.removeClass("open");
      this.contentContainer.slideUp(300);
    }
  }
}

$("[data-mhandle]").each(function() {
  new Mhandle($(this),
              $(this).find("[data-mhandle-role=title]"),
              $(this).find("[data-mhandle-role=content]"));
});

